/* eslint-disable react/forbid-prop-types */
import { useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { defaultProposalFilters } from 'features/CouncilPrequalification/defaultValues';

import {
  MultipleSelect,
  TextareaInput,
  // DatePicker,
  // TextInput,
} from 'components/FormControl';
import { TOAST } from 'constant';
import { toast } from 'layout';

function SearchFilters({
  visible,
  setVisible,
  filters,
  setFilters,
  appliedfilters,
  setAppliedFilters,
  programs,
  organizations,
  statuses,
  yearProposed,
}) {
  // #region Data
  const location = useLocation();
  const { t } = useTranslation();

  const { control, handleSubmit, reset, trigger } = useForm({
    mode: 'onChange',
    defaultValues: { statusName: ['submit', 'approved'] },
    shouldFocusError: true,
  });
  const { errors, isDirty, dirtyFields } = useFormState({
    control,
  });
  // #endregion Data

  // #region Event
  useEffect(() => {
    reset(filters);
    reset(appliedfilters);
  }, [filters, appliedfilters]);

  const onSubmit = (data) => {
    const submitData = { ...data };

    localStorage.setItem(`admin-${location.pathname.slice(1)}-filters`, JSON.stringify(submitData));

    setFilters(submitData);
    setAppliedFilters(submitData);
    setVisible(false);
  };

  const onClear = () => {
    reset({ statusName: ['submit', 'approved'] });
    localStorage.setItem(
      `admin-${location.pathname.slice(1)}-filters`,
      JSON.stringify(defaultProposalFilters)
    );
    setVisible(false);
    setFilters(defaultProposalFilters);
    setAppliedFilters(defaultProposalFilters);
  };

  const checkFormValid = async () => {
    const isValid = await trigger();
    if (!isValid) toast(TOAST.ERROR, t('errorMessage.validationErrorMessage'));
  };

  const checkKeyDown = (e) => {
    if (e.code === 'Enter') e.preventDefault();
  };
  // #endregion Event

  // #region Render
  return (
    <Dialog
      header={<p>{t('projectProposal.viewList.searchFilters')}</p>}
      visible={visible}
      position="center"
      className="w-8 md:w-8 lg:w-8 mx-1rem"
      onHide={() => setVisible(false)}
      draggable={false}
    >
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <form
        className="p-fluid"
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={checkKeyDown}
        autoComplete="off"
      >
        <div className="grid">
          {/* Vietnamese name */}
          <div className="col-12 md:col-6 lg:col-6">
            <TextareaInput
              label={t('proposalList.vietnameseName')}
              name="vietnameseName"
              control={control}
              errors={errors}
            />
          </div>
          {/* Owner name */}
          <div className="col-12 md:col-6 lg:col-6">
            <TextareaInput
              label={t('proposalList.ownerName')}
              name="ownerName"
              control={control}
              errors={errors}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-6">
            <MultipleSelect
              label={t('proposalList.organization')}
              name="organizationIds"
              options={organizations}
              inputField="id"
              renderField="name"
              control={control}
              errors={errors}
              panelStyle={{ maxWidth: '680px' }}
            />
          </div>
          {/* programId */}

          <div className="col-12 md:col-6 lg:col-6">
            <MultipleSelect
              label={t('proposalList.program')}
              name="proposalProgramIds"
              options={programs}
              inputField="id"
              renderField="name"
              control={control}
              errors={errors}
              panelStyle={{ maxWidth: '680px' }}
            />
          </div>
          {/* Statuses */}
          <div className="col-12 md:col-6 lg:col-6">
            <MultipleSelect
              label={t('proposalList.status')}
              name="status"
              options={statuses}
              inputField="code"
              renderField="name"
              control={control}
              errors={errors}
              panelStyle={{ maxWidth: '680px' }}
            />
          </div>

          <div className="col-12 md:col-6 lg:col-6">
            <MultipleSelect
              label={t('proposalList.yearProposed')}
              name="yearProposed"
              options={yearProposed}
              inputField="value"
              renderField="value"
              control={control}
              errors={errors}
              panelStyle={{ maxWidth: '680px' }}
            />
          </div>
        </div>

        <div className="flex justify-content-between">
          <Button
            label={t('projectProposal.viewList.clearFilter')}
            type="button"
            className="w-8rem"
            severity="danger"
            onClick={onClear}
          />

          <div className="flex justify-content-end gap-2">
            <Button
              label={t('formLayout.action.close')}
              type="button"
              className="w-7rem"
              severity="danger"
              onClick={() => setVisible(false)}
            />
            <Button
              label={t('employee.viewList.apply')}
              type="submit"
              className="w-7rem"
              severity="info"
              onClick={checkFormValid}
              disabled={!(isDirty && Object.keys(dirtyFields).length)}
            />
          </div>
        </div>
      </form>
    </Dialog>
  );
}

export default SearchFilters;

SearchFilters.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  appliedfilters: PropTypes.bool.isRequired,
  setAppliedFilters: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,

  // // eslint-disable-next-line react/forbid-prop-types
  programs: PropTypes.array,

  // eslint-disable-next-line react/require-default-props
  organizations: PropTypes.array,

  // // eslint-disable-next-line react/forbid-prop-types
  statuses: PropTypes.array,
  // // eslint-disable-next-line react/forbid-prop-types
  yearProposed: PropTypes.array,
};

SearchFilters.defaultProps = {
  programs: [],
  organizations: [],
  statuses: [],
  yearProposed: [],
};
